/**
 * Records a video/podcast play for the dashboard's Video & Podcast Plays table
 * (POST /api/track/media-play). Fire-and-forget: tracking never blocks or breaks
 * the player, and keepalive lets the request finish if the click leaves the page.
 *
 * @param {string} item   catalog key, e.g. 'media:12', 'freebie:<youtubeId>' (services/media/MediaPlayCatalog.js)
 * @param {'play'|'external'} [action]
 */
export function trackMediaPlay(item, action = 'play') {
    if (!item) return;
    try {
        fetch('/api/track/media-play', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ item, action, page: window.location.pathname }),
            keepalive: true
        }).catch(() => {});
    } catch { /* tracking is optional */ }
}
